import lazyload from 'app/libs/lazyload';

// common
export const RedirectPage = lazyload(() => import('./common/RedirectPage'));

// login pages
export const LoginPage = lazyload(() => import('./login/LoginPage'));

// snsLogin pages
export const SnsLoginPage = lazyload(() => import('./login/SnsLoginPage'));
// encarLogin pages
export const EncarLoginPage = lazyload(() => import('./login/EncarLoginPage'));
// account-management
export const AccountManagement = lazyload(() => import('./accountManagement/AccountManagementPage'));

// join pages
export const JoinPage = lazyload(() => import('./join/JoinPage'));

// cars pages
export const CarsPage = lazyload(() => import('./cars/CarsPage'));

// association pages
export const AssociationPage = lazyload(() => import('./association/AssociationPage'));

// myinfo pages
export const MyPage = lazyload(() => import('./my/MyPage'));

// homeservice pages
export const HomeservicePage = lazyload(() => import('./hs/HomeservicePage'));
export const GuidePage = lazyload(() => import('./hs/GuidePage'));

// loan
export const LoanPage = lazyload(() => import('./lo/LoanPage'));

// callback
export const CallbackPage = lazyload(() => import('./callback/CallbackPage'));

// company
export const CompanyPage = lazyload(() => import('./company/CompanyPage'));

// policy
export const PolicyPage = lazyload(() => import('./policy/PolicyPage'));

// clean-encar
export const PrivacyDocumentPage = lazyload(() => import('./cleanEncar/PrivacyDocumentPage'));
export const DocumentBridgePage = lazyload(() => import('./cleanEncar/DocumentBridgePage'));
export const DocumentTermsPage = lazyload(() => import('./cleanEncar/DocumentTermsPage'));

// landing
export const LandingPage = lazyload(() => import('./landing/LandingPage'));
export const NpsQaPage = lazyload(() => import('./qa/NpsQaPage'));

// estimate
export const EstimatePage = lazyload(() => import('./estimate/EstimatePage'));

// encarcenter
export const CenterPage = lazyload(() => import('./encarcenter/CenterPage'));

// image editor prototype
export const ImageUploaderPage = lazyload(() => import('./imageUploader/ImageUploaderPage'));

// service
export const DiagnosisPage = lazyload(() => import('./diagnosis/DiagnosisPage'));
export const ReportEvInfoPage = lazyload(() => import('./cars/ReportEvInfoPage'));

// premium diagnosis
export const PremiumDiagnosisPage = lazyload(() => import('./premiumDiagnosis/PremiumDiagnosisPage'));

// extended warranty
export const ExtendedWarrantyPage = lazyload(() => import('./ew/ExtendedWarrantyPage'));
export const CompensationPage = lazyload(() => import('./compensation/CompensationPage'));

// buyinquiry
export const BuyInquiryPage = lazyload(() => import('./buyinquiry/BuyInquiryPage'));

// encarpay
export const EncarpayPage = lazyload(() => import('./encarpay/EncarpayPage'));

// board
export const BoardPage = lazyload(() => import('./board/BoardPage'));

// ohmycall
export const OhMyCallPage = lazyload(() => import('./ohmycall/OhMyCallPage'));

// escrow pages
export const EscrowPage = lazyload(() => import('./escrow/EscrowPage'));

// self pages
export const SelfRegisterPage = lazyload(() => import('./selfRegister/SelfRegisterPage'));
// preinspection pages
export const CarVerificationPage = lazyload(() => import('./carVerification/CarVerificationPage'));

// escrow-v2
export const EscrowV2Page = lazyload(() => import('./escrow-v2'));

// meetgo
export const MeetgoPage = lazyload(() => import('./meetgo/MeetgoPage'));

// 전자계약서 모듈
export const ContractsPage = lazyload(() => import('./contracts/ContractsPage'));

// loan pages
export const UsedCarLoanPage = lazyload(() => import('./usedCarLoan/UsedCarLoanPage'));

// 미리배송 (h2)
export const PreDeliveryPage = lazyload(() => import('./preDelivery/PreDeliveryPage'));
// inspection center
export const InspectionCenterPage = lazyload(() => import('./inspectionCenter/InspectionCenterPage'));

// consumer
export const ConsumerPage = lazyload(() => import('./consumer/ConsumerPage'));

// 구글캡차 인증화면 (비정상적인 페이지 요청으로 차단된 사용자)
export const ClientVerificationBlockedPage = lazyload(() => import('./client-verification/ClientVerificationBlockedPage'));

// 쿠폰
export const CouponPage = lazyload(() => import('./coupon/CouponPage'));
